import { Component, OnInit,Input } from '@angular/core';
import { FormArray} from '@angular/forms';

@Component({
  selector: 'app-locks-list',
  templateUrl: './locks-list.component.html',
  styleUrls: ['./locks-list.component.scss']
})
export class LocksListComponent implements OnInit {

  constructor() {}

  @Input()
  lockComponent_Hide=true;

  @Input()
  lockComponentTitleContent= 'LOCKS';
  
  @Input()
  lockComponentListContent: FormArray = new FormArray([]);

  ngOnInit(): void {}

}
